// extracted by mini-css-extract-plugin
module.exports = {"resultText":"BodyPageProducts_resultText__MZjGN"};